import {
    DesignVariablesKeyInCustomCode,
    FeedPreVariablesKeyInCustomCode,
} from "../../../components/BannerEditor/VariablesForm";
import {feedPostCC} from "../variables/saga";


const cc = `setup:
let FeedName = "sephora_fr_sample"

## ProductIds from high intent to low intent
let ProductId1 = User._af_initiated_checkout.ids or ""
let ProductId2 = User._af_add_to_cart.ids or ""
let ProductId3 = User._af_content_view.ids or ""
let ProductId4 = User._af_list_view.ids or ""

## Get the all recommended offers based on the preferred offer
let FeedOffers = Feed.SelectN(FeedName, 12, ProductId1, ProductId2, ProductId3, ProductId4)

let LogoClickUrl = ""
let OverlayClickUrl = ""

##### Variables Macro. Dont remove.#####
#FeedPostVars#
${feedPostCC({})}
#EndFeedPostVars#
#### End of Variables Macro. Dont remove.#####
`;


export default cc;